module.exports = __webpack_public_path__ + "img/Vessel-IT-Support-Executive.938897de.webp";